export default [
  {
    path: "subAccounts",
    name: "subAccounts",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:subAccounts" */ "@/views/Webmaster/SubAccountsView.vue")
  }
];
